import React from "react";
import video from "../../../assets/hero.mp4";
import { Link } from "react-router-dom";
import iiImage from "../../../assets/II Website Image - Top Right.png"
import heroVideoBg from "../../../assets/hero-video-bg.webp";

const Banner = () => {
  return (
    <div className="banner pt-[52px] pb-[196px] min-h-[90vh] relative overflow-hidden">
      {/* <video
        src={video}
        className="w-full h-full absolute top-0 left-0 object-bottom object-cover"
        autoPlay
        muted
        loop
      ></video> */}

      <video
        playsinline="playsinline"
        autoplay="autoplay"
        loop="loop"
        muted="muted"
        preload="metadata"
        className="w-full h-full absolute top-0 left-0 object-bottom object-cover"
        poster={heroVideoBg}
      >
        <source src={video} type="video/mp4" />
        <img src={heroVideoBg} alt="hero-img" />
      </video>

      <div className="container mx-auto relative z-10">
        <div className="grid lg:grid-cols-2 grid-cols-1 gap-10">
          <div className="left">
            <h1
              className="text-black text-[40px] lg:text-[60px] font-bold mb-16 lg:text-start text-center"
              style={{ lineHeight: "1.2" }}
            >
              The  <span className="besley italic font-light">ultimate toolkit</span>{" "}
              to <br /> connect with fans <br /> who want more
            </h1>

            <Link
              to="/contact"
              className="text-white bg-black border-0 uppercase px-4 py-3 rounded-[6px] font-semibold lg:inline hidden"
            >
              Get Started
            </Link>
          </div>
          <div className="right">
            <img src={iiImage} className="w-full" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
